"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFrontApp = exports.getURL_API = exports.getProcessNameAndPrefix = exports.getDeviceInfo = exports.errorBehaviourChecker = exports.toKebabCase = exports.deleteCookie = exports.setCookie = exports.getCookie = exports.normalizeString = exports.getUrlParams = exports.myAssign = exports.makeUpObj = exports.cleanUnAllowedKeysInsideObject = exports.getDeviceKindDependsOnViewPort = exports.getViewPortSize = void 0;
const query_string_1 = __importDefault(require("query-string"));
const next12_utils_constants_1 = require("@gcloud-npm/next12.utils.constants");
/**
 * getViewPortSize: get viewport size
 * @returns {number, number} width height
 */
const getViewPortSize = () => {
    let viewPortWidth;
    let viewPortHeight;
    let clientWidth = 1000;
    let clientHeight = 600;
    try {
        ({ clientWidth } = document.getElementsByTagName("body")[0]);
        ({ clientHeight } = document.getElementsByTagName("body")[0]);
    }
    catch (err) {
        // we have tryied get values
    }
    /* the more standards compliant browsers (mozilla/netscape/opera/IE7)
      use window.innerWidth and window.innerHeight */
    if (window.innerWidth) {
        viewPortWidth = window.innerWidth;
        viewPortHeight = window.innerHeight;
    }
    // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
    else if (document.documentElement &&
        document.documentElement.clientWidth &&
        document.documentElement.clientWidth !== 0) {
        viewPortWidth = document.documentElement.clientWidth;
        viewPortHeight = document.documentElement.clientHeight;
    }
    else {
        viewPortWidth = clientWidth;
        viewPortHeight = clientHeight;
    }
    return { viewPortWidth, viewPortHeight };
};
exports.getViewPortSize = getViewPortSize;
/** getKindDeviceByViewportSize
 * @param {array} array - Original array
 * @param {array} newItems - Array of new items
 */
const getDeviceKindDependsOnViewPort = () => {
    let res = next12_utils_constants_1.DEVICES.MOBILE;
    if (typeof window !== "undefined") {
        // client-side-only code
        const { viewPortWidth } = (0, exports.getViewPortSize)();
        if (viewPortWidth >= 980) {
            res = next12_utils_constants_1.DEVICES.PC;
        }
        if (viewPortWidth >= 768 && viewPortWidth < 980) {
            res = next12_utils_constants_1.DEVICES.TABLET;
        }
        return res;
    }
    return res;
};
exports.getDeviceKindDependsOnViewPort = getDeviceKindDependsOnViewPort;
/**
 * cleanUnAllowedKeysInsideObject
 * @param {object} object2Clean object to clean
 * @param {Array<RegExp>} allowedKeys array of RegEx like: allowed: []
 * @returns {object} cleaned structure
 */
const cleanUnAllowedKeysInsideObject = (object2Clean, allowedKeys) => {
    const newObjectCleaned = Object.assign({}, object2Clean);
    // looping
    const keys = Object.keys(object2Clean);
    keys.forEach((key) => {
        let allowed = false;
        allowedKeys.forEach((regItem) => {
            const regEx = new RegExp(regItem);
            if (regEx.test(key) && !allowed) {
                allowed = true;
            }
        });
        if (!allowed) {
            delete newObjectCleaned[key];
        }
    });
    return newObjectCleaned;
};
exports.cleanUnAllowedKeysInsideObject = cleanUnAllowedKeysInsideObject;
/**
 * makeUpObj
 * @param {object} objRes object used to write the final result
 * @param {string} key path inside object whete you want to place it like: info.data
 * @param {string||number} value value to associate
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */
const makeUpObj = (key, value) => {
    const obj = {};
    const parts = key.split(".");
    if (parts.length === 1) {
        obj[parts[0]] = value;
    }
    else if (parts.length > 1) {
        // concat all but the first part of the key
        const remainingParts = parts.slice(1, parts.length).join(".");
        obj[parts[0]] = (0, exports.makeUpObj)(remainingParts, value);
    }
    return obj;
};
exports.makeUpObj = makeUpObj;
/**
 * myAssign
 * @param {object} obj object where you desire to assing something (it does not matter is empty or not)
 * @param {string} keyPathDotNotation path inside object whete you want to place it like: info.data already splited by .
 * @param {string||number} value value to associate
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */
const myAssign = (sourceObj, targetObj) => {
    const res = Object.assign(sourceObj, targetObj);
    return res;
};
exports.myAssign = myAssign;
/**
 * getUrlParams
 * @param {bool} groupByObject object used to write the final result
 * @param {array} allowedKeys array of RegEx like: allowed: []
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */
const getUrlParams = (arg = {
    groupByObject: false,
    allowedParams: null,
    currentUrl: "",
}) => {
    let params = null;
    const { groupByObject, allowedParams, currentUrl } = arg;
    try {
        let hashInfo;
        let searchParams;
        let hashRouterParasm;
        let beginPosition;
        let string2Analise;
        // detecting if we have # has router
        if (currentUrl) {
            const currentUrlObj = new URL(currentUrl);
            hashInfo = currentUrlObj.hash;
            searchParams = currentUrlObj.search;
            hashRouterParasm =
                hashInfo && !searchParams && hashInfo.indexOf("?") > -1;
            if (hashRouterParasm) {
                beginPosition = hashInfo.indexOf("?");
                string2Analise = hashInfo.substr(beginPosition);
            }
        }
        else {
            hashInfo = !!window.location.hash;
            const issearchParams = !!window.location.search;
            searchParams = window.location.search;
            hashRouterParasm =
                hashInfo && !issearchParams && window.location.hash.indexOf("?") > -1;
            if (hashRouterParasm) {
                beginPosition = window.location.hash.indexOf("?");
                string2Analise = window.location.hash.substr(beginPosition);
            }
        }
        if (hashRouterParasm) {
            // TODO: refactor to new urlSeachParams() api
            params = query_string_1.default.parse(string2Analise);
        }
        else {
            params = query_string_1.default.parse(searchParams);
        }
    }
    catch (err) {
        console.error(err);
    }
    // cleaning function
    if (Array.isArray(allowedParams) && params) {
        params = (0, exports.cleanUnAllowedKeysInsideObject)(params, allowedParams);
    }
    // groupby . as object
    if (groupByObject) {
        let groupuedParams = {};
        const paramsKeys = Object.keys(params);
        paramsKeys.forEach((paramsKey) => {
            const value = params[paramsKey];
            if (paramsKey.indexOf(".") !== -1) {
                const auxObj = (0, exports.makeUpObj)(paramsKey, value);
                groupuedParams = (0, exports.myAssign)(groupuedParams, auxObj);
            }
            else {
                groupuedParams[paramsKey] = value;
            }
        });
        params = groupuedParams;
    }
    return params;
};
exports.getUrlParams = getUrlParams;
/**
 * NOrmaliza un string, generalmente para el envio de metrics
 * @param {string} str a transformar.
 * @returns {string} myExample --> my-example
 */
const normalizeString = (str) => {
    let newStr = str;
    newStr = newStr.toLowerCase();
    newStr = newStr.replace(/á/g, "a");
    newStr = newStr.replace(/é/g, "e");
    newStr = newStr.replace(/í/g, "i");
    newStr = newStr.replace(/ó/g, "o");
    newStr = newStr.replace(/ú/g, "u");
    newStr = newStr.replace(/ /g, "-");
    newStr = newStr.replace(/ñ/g, "n");
    return newStr;
};
exports.normalizeString = normalizeString;
/**
 * It gets cookie value using cookie name
 * @param cName cookie Name
 * @returns {string} cookie Value
 */
const getCookie = (cName) => {
    let cValue = document && document.cookie ? document.cookie : "";
    if (cValue) {
        let cStart = cValue.indexOf(` ${cName}=`);
        if (cStart === -1) {
            cStart = cValue.indexOf(`${cName}=`);
        }
        if (cStart === -1) {
            cValue = "";
        }
        else {
            cStart = cValue.indexOf("=", cStart) + 1;
            let cEnd = cValue.indexOf(";", cStart);
            if (cEnd === -1) {
                cEnd = cValue.length;
            }
            cValue = unescape(cValue.substring(cStart, cEnd));
        }
    }
    return cValue;
};
exports.getCookie = getCookie;
/**
 * setCookie: Set a cookie
 * @param cName name of cookie that we want to modify
 * @param value value that we want to set to the cookie
 * @param exdays available cookie time from this moment
 * @param domain domains where the cookie aplies
 * @param needScape boolean if we want to scape special characters
 * @returns {void}
 */
const setCookie = (cName, value, exdays, domain = "", needScape = true) => {
    const exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    let cValue = "";
    const parsedValue = needScape ? escape(value) : value;
    if (!domain) {
        cValue =
            parsedValue +
                (exdays === null ? "" : `;expires=${exdate.toUTCString()};path=/`);
    }
    else {
        cValue =
            parsedValue +
                (exdays === null
                    ? ""
                    : `;expires=${exdate.toUTCString()};domain=${domain};path=/`);
    }
    document.cookie = `${cName}=${cValue}`;
};
exports.setCookie = setCookie;
/**
 * deleteCookie: Delete a cookie
 * @param name name of the cookie that we want to delete
 * @returns {void}
 */
const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
};
exports.deleteCookie = deleteCookie;
/**
 * Convierte a kebab case una cadena.
 * @param {string} cadena a transformar.
 * @returns {string} myExample --> my-example
 */
const toKebabCase = (entry = "") => {
    let kebapName = entry
        .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2")
        .toLowerCase();
    if (kebapName[0] === "-") {
        kebapName = kebapName.substr(1);
    }
    return kebapName;
};
exports.toKebabCase = toKebabCase;
const errorBehaviourChecker = (index = "") => {
    let res = false;
    try {
        res = window.location.search.indexOf(`errorBehaviourChecker${index}`) > -1;
        return res;
    }
    catch (error) {
        return res;
    }
};
exports.errorBehaviourChecker = errorBehaviourChecker;
/**
 * getDeviceInfo: Detect info about where and how the page is executed
 * output example:
 * {
 *  "os":{"name":"Windows","version":10},
 *  "browser":{"name":"Chrome","version":80.03987149},
 *  "navigator":{
 *    "userAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64)
 *     AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.149 Safari/537.36",
 *    "appVersion":"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko)
 *     Chrome/80.0.3987.149 Safari/537.36",
 *    "platform":"Win32","vendor":"Google Inc."
 *   }
 * }
 * @returns {object} for example: {href: 'https://www.movistar.es', referrer: 'https://www.google.com'}
 */
const getDeviceInfo = () => {
    const module = {
        options: [],
        header: [
            navigator.platform,
            navigator.userAgent,
            navigator.appVersion,
            navigator.vendor,
        ],
        dataos: [
            { name: "Windows Phone", value: "Windows Phone", version: "OS" },
            { name: "Windows", value: "Win", version: "NT" },
            { name: "iPhone", value: "iPhone", version: "OS" },
            { name: "iPad", value: "iPad", version: "OS" },
            { name: "Kindle", value: "Silk", version: "Silk" },
            { name: "Android", value: "Android", version: "Android" },
            { name: "PlayBook", value: "PlayBook", version: "OS" },
            { name: "BlackBerry", value: "BlackBerry", version: "/" },
            { name: "Macintosh", value: "Mac", version: "OS X" },
            { name: "Linux", value: "Linux", version: "rv" },
            { name: "Palm", value: "Palm", version: "PalmOS" },
        ],
        databrowser: [
            { name: "Chrome", value: "Chrome", version: "Chrome" },
            { name: "Firefox", value: "Firefox", version: "Firefox" },
            { name: "Safari", value: "Safari", version: "Version" },
            { name: "Internet Explorer", value: "MSIE", version: "MSIE" },
            { name: "Opera", value: "Opera", version: "Opera" },
            { name: "BlackBerry", value: "CLDC", version: "CLDC" },
            { name: "Mozilla", value: "Mozilla", version: "Mozilla" },
        ],
    };
    const matchItem = (string, data) => {
        let i = 0;
        let j = 0;
        let regex;
        let regexv;
        let match;
        let matches;
        let version;
        for (i = 0; i < data.length; i += 1) {
            regex = new RegExp(data[i].value, "i");
            match = regex.test(string);
            if (match) {
                regexv = new RegExp(`${data[i].version}[- /:;]([\\d._]+)`, "i");
                matches = string.match(regexv);
                version = "";
                if (matches) {
                    if (matches[1]) {
                        matches = matches[1];
                    }
                }
                if (matches) {
                    matches = matches.split(/[._]+/);
                    for (j = 0; j < matches.length; j += 1) {
                        if (j === 0) {
                            version += `${matches[j]}.`;
                        }
                        else {
                            version += matches[j];
                        }
                    }
                }
                else {
                    version = "0";
                }
                return {
                    name: data[i].name,
                    version: parseFloat(version),
                };
            }
        }
        return { name: "unknown", version: 0 };
    };
    const init = () => {
        const agent = module.header.join(" ");
        const os = matchItem(agent, module.dataos);
        const browser = matchItem(agent, module.databrowser);
        const navigatorData = {
            userAgent: navigator.userAgent,
            appVersion: navigator.appVersion,
            platform: navigator.platform,
            vendor: navigator.vendor,
        };
        return {
            os,
            browser,
            navigator: navigatorData,
        };
    };
    const info = init();
    return info;
};
exports.getDeviceInfo = getDeviceInfo;
/**
 * Devuelve el processName y prefix
 * @param {string} userType -> Puede ser Telco o ''
 * @returns {object} processName y prefixToApply
 */
const getProcessNameAndPrefix = (userType) => {
    let processName = next12_utils_constants_1.PROCESS_NAME.OPEN;
    let prefixToApply = next12_utils_constants_1.PREFIX_TO_APPLY.OPEN;
    if (userType && userType === "Telco") {
        processName = next12_utils_constants_1.PROCESS_NAME.CLIENT;
        prefixToApply = next12_utils_constants_1.PREFIX_TO_APPLY.CLIENT;
    }
    return { processName, prefixToApply };
};
exports.getProcessNameAndPrefix = getProcessNameAndPrefix;
/**
 * Devuelve el processName y prefix
 * @param {string} path -> URL inicial
 * @param {string} version -> Version de api de TELCO
 * @param {string} idRequest
 * @param {string} host
 * @param {string} prefixToApply
 * @param {string} queryParams -> Parametros a concatenar en la url
 * @param {string} urlParamsToReplace -> Parametros a sustituir en la url
 * @returns {object} URL a la que hacer la request
 */
const getURL_API = ({ path, version, idRequest, host, prefixToApply, queryParams, urlParamsToReplace, }) => {
    const pathBegin = path.substring(0, path.indexOf("/"));
    const pathEnd = path.substring(path.indexOf("/") + 1, path.length);
    let finalEndpoint = `${host}${prefixToApply}${pathBegin}/`;
    if (version) {
        finalEndpoint = `${finalEndpoint}v${version}/`;
    }
    finalEndpoint = `${finalEndpoint}${pathEnd}?${idRequest}`;
    if (queryParams && Array.isArray(queryParams) && queryParams.length > 0) {
        for (const queryParam of queryParams) {
            const { param, value } = queryParam;
            if (param) {
                if (!Object.prototype.hasOwnProperty.call(queryParam, "value")) {
                    finalEndpoint += `&${param}`;
                }
                else if (value !== undefined) {
                    finalEndpoint += `&${param}=${String(value)}`;
                }
            }
        }
    }
    if (urlParamsToReplace &&
        Array.isArray(urlParamsToReplace) &&
        urlParamsToReplace.length > 0) {
        urlParamsToReplace.forEach((paramToReplace) => {
            const { param, value } = paramToReplace;
            finalEndpoint = finalEndpoint.replace(param, String(value));
        });
    }
    return finalEndpoint;
};
exports.getURL_API = getURL_API;
const isFrontApp = () => {
    let result = false;
    if (typeof window !== "undefined") {
        result = true;
    }
    return result;
};
exports.isFrontApp = isFrontApp;
//# sourceMappingURL=index.js.map